"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSchema = exports.TimeUnits = void 0;
exports.TimeUnits = ['SECONDS', 'MINUTES', 'HOURS', 'DAYS', 'WEEKS', 'MONTHS', 'YEARS'];
var schema_1 = require("./schema");
Object.defineProperty(exports, "SearchSchema", { enumerable: true, get: function () { return schema_1.SearchSchema; } });
//# sourceMappingURL=index.js.map